<template>
	<div style="position: relative;background-color: #b5edf2;">
		<div style="position: relative;">
			<img src="../assets/ranking-banner.png" style="width: 100%;" />
		</div>
		<div class="rank-frame">
			<div class="rank-num">{{personal.ranknum}}</div>
		</div>
		
		<div style="position: relative;font-size: 0;">
			<img src="../assets/points-box.png" style="width: 100%;"/>
			<div class="sum-point">{{personal.totalscore}}</div>
			<div class="warm-point">{{personal.yrscore}}</div>
			<div class="book-point">{{personal.listenscore}}</div>
		</div>
		<div style="position: relative;font-size: 0;">
			<img src="../assets/prev-rank-gap.png" style="width: 100%;"/>
			<div class="prev-point">{{personal.scoredifference}}</div>
		</div>
		<div style="position: relative;margin-top: 30px;">
			
			<div class="rank-list">
				<div class="rank-title">
					<div class="rank-title1">排名</div>
					<div class="rank-title2">手机号</div>
					<div class="rank-title2">总积分</div>
				</div>
				<div class="rank-title" v-for="(item,index) in ranklist">
					<div class="rank-title1">{{index+1}}</div>
					<div class="rank-title2">{{item.phone}}</div>
					<div class="rank-title2">{{item.score}}</div>
				</div>
			</div>
			<img src="../assets/leaderboard-title.png" style="position: absolute;top: 0;left: 0;width: 50%;transform: translateY(-50%);"/>
		</div>
		<div style="text-align: center;">
			<img src="../assets/ranking-info.png" style="width: 95%;padding: 30px 0;"/>
			<div>
				<img @click="back" src="../assets/back-button.png" style="width: 40%;padding: 0px 0 30px;"/>
			</div>
		</div>
		
		
		<div v-if="loading_flag" style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 999;">
			<img src="../assets/loading.gif" style="width: 30px;position: absolute;top: 45%;left: 50%;transform: translate(-50%);" />
		</div>
	</div>
</template>

<script>
	
	import Vue from 'vue';
	import Toast from 'vant/lib/toast';
	import 'vant/lib/toast/style';
	Vue.use(Toast);
	export default {
		name: 'Rank',
		components: {

		},
		data() {
			return {
				
				
				loading_flag:false,
				personal:{
				  yrscore: null,
				  listenscore: null,
				  totalscore: null,
				  ranknum: null,
				  scoredifference: null
				},
				ranklist:[]
			}
		},

		methods: {
			back(){
				this.$router.back()
			},
			get_rank_info() {
				let post = {
					"jytoken": window.tokenss
				}
				post = JSON.stringify(post)
				this.$api.get('/formal_rank.php', {
					params: {
						message: post
					}
				}).then(data => {
					console.log(data)
					if(data.data.code==1){
						this.personal = data.data.data.personal
						this.ranklist = data.data.data.ranklist
					}else{
						Toast(data.data.data)
					}
				})
			},
		},
		mounted() {
			this.get_rank_info()
		}
	}
</script>

<style scoped>
	.rank-frame {
		position: relative;
		margin-top: -10px;
		background-image: url('../assets/rank-frame.png');
		background-size: 100% 100%;
		text-align: center;
		padding: 12vw 0 1vw;
	}

	.rank-num {
		font-size: 8rem;
		line-height: 7.5rem;
		font-weight: bolder;
		color: #e61818;
		text-shadow:
			-1px -1px 0 #fff,
			1px -1px 0 #fff,
			-1px 1px 0 #fff,
			1px 1px 0 #fff;
		/* 黑色阴影，形成描边效果 */
	}
	.rank-num {
		font-size: 8rem;
		line-height: 7.5rem;
		font-weight: bolder;
		color: #e61818;
		text-shadow:
			-1px -1px 0 #fff,
			1px -1px 0 #fff,
			-1px 1px 0 #fff,
			1px 1px 0 #fff;
		/* 黑色阴影，形成描边效果 */
	}
	.sum-point{
		position: absolute;
		bottom: 60%;
		left: 35%;
		color: #e61818;
		font-weight: bolder;
		font-size: 2rem;
		width: 50%;
		
	}
	.warm-point{
		position: absolute;
		top: 62%;
		left: 9%;
		color: #e61818;
		font-weight: bolder;
		font-size: 1.5rem;
		text-align: center;
		width: 30%;
	}
	.book-point{
		position: absolute;
		top: 62%;
		left: 60%;
		color: #e61818;
		font-weight: bolder;
		font-size: 1.5rem;
		text-align: center;
		width: 30%;
	}
	.prev-point{
		position: absolute;
		top: 0%;
		left: 38%;
		color: #e61818;
		font-weight: bolder;
		font-size: 1.5rem;
		text-align: center;
		width: 55%;
		height: 100%;
		display: flex;
		align-items: center;
	}
	.rank-list{
		position: relative;
		font-size: 0;
		padding: 40px 10px 10px;
		margin: 0 2.5%;
		box-sizing: border-box;
		box-shadow: 0 0 10px rgba(133, 219, 245, 0.8);
		background-color: #fff;
		border-radius: 15px;
	}
	.rank-title{
		display: flex;
		align-items: center;
		font-size: 1rem;
		color: #333;
		font-weight: bold;
		text-align: center;
		margin-bottom: 10px;
	}
	.rank-title1{
		width: 15%;
	}
	.rank-title2{
		width: 43%;
	}
	.rank-title3{
		width: 0;
		flex: 1;
	}
</style>